(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tf-mobile-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tf-mobile-menu')) {
 customElements.define('tf-mobile-menu', class extends HTMLElement {
  connectedCallback() {
   if (this.lifecycle) return;
   this.dialog = this.querySelector('dialog');
   if (!this.dialog) return;
   this.lifecycle = new AbortController();
   const signal = this.lifecycle.signal;
   this.main = this.querySelector('[data-mobile-main]');
   this.screens = [...this.querySelectorAll('[data-mobile-screen]')];
   this.heading = this.querySelector('.tf-m-menu__title');
   this.back = this.querySelector('[data-mobile-back]');
   this.viewport = matchMedia('(max-width:1149px)');
   this.bindTriggers();
   document.addEventListener('click', event => {
    const trigger = event.target.closest('.selluxe_mobile-menu');
    if (!trigger || !this.viewport.matches) return;
    event.preventDefault();
    this.show(trigger);
   }, {signal});
   this.dialog.addEventListener('click', event => {
    if (event.target === this.dialog) {
     const r = this.dialog.getBoundingClientRect();
     if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
    }
    if (event.target.closest('[data-mobile-close]')) this.dialog.close();
    if (event.target.closest('[data-mobile-back]')) this.goBack();
    const next = event.target.closest('[data-mobile-submenu]');
    if (next) this.openScreen(next);
   }, {signal});
   this.dialog.addEventListener('cancel', event => {
    if (this.activeScreen) { event.preventDefault(); this.goBack(); }
   }, {signal});
   this.dialog.addEventListener('close', () => this.restore(), {signal});
   this.viewport.addEventListener('change', () => { if (!this.viewport.matches && this.dialog.open) this.dialog.close(); }, {signal});
   document.addEventListener('shopify:section:load', () => this.bindTriggers(), {signal});
   document.addEventListener('shopify:block:select', event => {
    if (!this.viewport.matches || event.detail?.sectionId !== this.dataset.sectionId) return;
    const screen = this.screens.find(item => item.dataset.menuBlock === event.detail.blockId);
    const mapping = [...this.querySelectorAll('[data-shopify-editor-block]')].find(item => {
     try { return JSON.parse(item.dataset.shopifyEditorBlock).id === event.detail.blockId; } catch { return false; }
    });
    if (!screen && !mapping) return;
    this.show(document.querySelector('.selluxe_mobile-menu'));
    if (screen) this.openScreen(this.querySelector(`[data-mobile-submenu="${screen.id}"]`));
    if (mapping) { this.goBack(false); mapping.scrollIntoView({block:'center'}); }
   }, {signal});
  }
  bindTriggers() {
   document.querySelectorAll('.selluxe_mobile-menu').forEach(trigger => {
    trigger.setAttribute('type','button');
    trigger.setAttribute('aria-controls',this.dialog.id);
    trigger.setAttribute('aria-expanded',String(this.dialog.open));
    trigger.setAttribute('aria-haspopup','dialog');
    if (!trigger.hasAttribute('aria-label')) trigger.setAttribute('aria-label',this.dataset.mainTitle);
   });
  }
  show(trigger) {
   if (this.dialog.open || !this.viewport.matches) return;
   this.trigger = trigger;
   this.goBack(false);
   const doc = document.documentElement;
   this.previousOverflow = doc.style.overflow;
   doc.style.overflow = 'hidden';
   this.dialog.showModal();
   this.bindTriggers();
   this.querySelector('[data-mobile-close]').focus({preventScroll:true});
  }
  openScreen(trigger) {
   const screen = this.screens.find(item => item.id === trigger?.dataset.mobileSubmenu);
   if (!screen) return;
   this.screens.forEach(item => item.hidden = item !== screen);
   this.main.hidden = true;
   this.back.hidden = false;
   this.activeScreen = screen;
   this.activeTrigger = trigger;
   trigger.setAttribute('aria-expanded','true');
   this.heading.textContent = screen.dataset.title;
   screen.querySelector('.tf-m-menu__scroll').scrollTop = 0;
   this.back.focus({preventScroll:true});
  }
  goBack(focus = true) {
   this.screens.forEach(item => item.hidden = true);
   this.main.hidden = false;
   this.back.hidden = true;
   this.heading.textContent = this.dataset.mainTitle;
   this.activeScreen = null;
   this.activeTrigger?.setAttribute('aria-expanded','false');
   if (focus) this.activeTrigger?.focus({preventScroll:true});
   this.activeTrigger = null;
  }
  restore() {
   if (this.previousOverflow !== undefined) {
    document.documentElement.style.overflow = this.previousOverflow;
    this.previousOverflow = undefined;
   }
   this.goBack(false);
   this.bindTriggers();
   if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
  }
  disconnectedCallback() {
   this.lifecycle?.abort();
   this.lifecycle = null;
   if (this.dialog?.open) this.dialog.close();
   if (this.dialog) this.restore();
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tf-payment-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tf-payment-options')) {
    customElements.define('tf-payment-options', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const opener = event.target.closest('[data-payment-open]');
          if (opener) {
            this.opener = opener;
            const dialog = this.querySelector('dialog[data-provider="' + opener.dataset.paymentOpen + '"]');
            if (dialog && !dialog.open) {
              dialog.showModal();
              document.documentElement.classList.add('tf-payment-is-open');
            }
          }
          if (event.target.closest('[data-payment-close]')) event.target.closest('dialog')?.close();
          const mode = event.target.closest('[data-payment-mode]');
          if (mode) {
            const dialog = mode.closest('dialog');
            dialog.querySelectorAll('[data-payment-mode]').forEach(button => button.setAttribute('aria-pressed', String(button === mode)));
            dialog.querySelectorAll('[data-payment-panel]').forEach(panel => { panel.hidden = panel.dataset.paymentPanel !== mode.dataset.paymentMode; });
          }
        }, options);
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('keydown', event => {
            if (event.key !== 'Tab') return;
            const focusable = [...dialog.querySelectorAll('button:not(:disabled), a[href]')].filter(element => element.getClientRects().length);
            const first = focusable[0], last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault(); last?.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault(); first?.focus();
            }
          }, options);
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, options);
          dialog.addEventListener('close', () => {
            if (!document.querySelector('.tf-payment-dialog[open]')) document.documentElement.classList.remove('tf-payment-is-open');
            if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
          }, options);
        });
        document.addEventListener('variant:change', event => {
          if (event.detail?.formId === this.dataset.form && event.detail.variant) this.updatePrice(event.detail.variant.price);
        }, options);
      }
      updatePrice(price) {
        if (!Number.isFinite(price) || price < 0) return;
        const first = Math.round(price / 3);
        const amounts = { first, second: first, third: price - first * 2, total: price };
        const format = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: this.dataset.currency || 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        this.dataset.price = String(price);
        this.querySelectorAll('[data-payment-amount]').forEach(element => {
          const cents = amounts[element.dataset.paymentAmount];
          element.textContent = format.format(cents / 100);
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        if (!document.querySelector('.tf-payment-dialog[open]')) document.documentElement.classList.remove('tf-payment-is-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tf-search-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tf-search-panel')) {
  customElements.define('tf-search-panel', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('.shopify-section')?.querySelector('.tf-header-search');
      if (!this.form || this.panel) return;
      this.input = this.form.querySelector('input[name="q"]');
      this.panel = this.querySelector('.tf-s-panel');
      this.shade = this.querySelector('.tf-s-shade');
      this.initial = this.panel.querySelector('.tf-s-initial');
      this.results = this.panel.querySelector('.tf-s-results');
      this.status = this.panel.querySelector('.tf-s-status');
      this.events = new AbortController();
      this.base = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
      this.input.setAttribute('aria-controls', this.panel.id);
      this.input.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('autocomplete', 'off');
      document.body.append(this.shade, this.panel);
      const on = (el, type, fn) => el.addEventListener(type, fn, {signal:this.events.signal});
      on(this.input, 'focus', () => { this.open(); this.queue(); });
      on(this.input, 'input', () => { this.open(); this.queue(); });
      on(this.input, 'keydown', e => { if(e.key === 'ArrowDown' && !this.panel.hidden) { e.preventDefault(); this.panel.querySelector('a')?.focus(); } });
      on(this.panel.querySelector('.tf-s-close'), 'click', () => this.close(true));
      on(this.shade, 'click', () => this.close(false));
      on(document, 'keydown', e => { if(e.key === 'Escape' && !this.panel.hidden) { e.preventDefault(); this.close(true); } });
      on(document, 'focusin', e => { if(!this.panel.hidden && !this.panel.contains(e.target) && !this.form.contains(e.target)) this.close(false); });
      on(this.panel, 'click', e => { const a=e.target.closest('[data-search-term]'); if(a) { e.preventDefault(); this.input.value=a.dataset.searchTerm; this.input.focus(); this.queue(); } });
      on(window, 'resize', () => this.position());
      on(window, 'scroll', () => { if(!this.panel.hidden) this.position(); });
      this.remember();
    }
    open() {
      if(this.suppress) return;
      this.panel.hidden=false; this.shade.hidden=false; this.input.setAttribute('aria-expanded','true');
      this.header=this.form.closest('.shopify-section');
      if(this.header && this.savedZ===undefined) {this.savedZ=this.header.style.zIndex;this.header.style.zIndex='20';}
      this.header?.querySelectorAll('details[open]').forEach(d=>d.removeAttribute('open'));
      this.position();
      if(!this.recentLoaded) {this.recentLoaded=true;this.recent();}
    }
    close(focus) {
      this.panel.hidden=true;this.shade.hidden=true;this.input.setAttribute('aria-expanded','false');
      clearTimeout(this.timer); this.request?.abort(); this.sequence=(this.sequence||0)+1;
      if(this.header && this.savedZ!==undefined){this.header.style.zIndex=this.savedZ;this.savedZ=undefined;}
      if(focus){this.suppress=true;this.input.focus();this.suppress=false;}
    }
    position() {
      if(this.panel.hidden)return;
      const r=this.form.getBoundingClientRect();
      const top=Math.max(8,Math.min(r.bottom+12,window.innerHeight-120));
      this.panel.style.top=top+'px';this.panel.style.maxHeight=(window.innerHeight-top-12)+'px';
    }
    queue() {
      if(this.suppress)return;
      clearTimeout(this.timer);this.request?.abort();const seq=this.sequence=(this.sequence||0)+1;
      const q=this.input.value.trim();this.initial.hidden=!!q;this.results.hidden=!q;this.status.textContent='';
      if(!q){this.results.replaceChildren();return;}
      this.results.replaceChildren();this.status.textContent='Zoeken…';
      this.timer=setTimeout(()=>this.search(q,seq),200);
    }
    async search(q,seq) {
      this.request=new AbortController();
      try {
        const u=new URL(this.dataset.predictiveUrl,location.origin);
        u.searchParams.set('q',q);u.searchParams.set('resources[type]','product,query');u.searchParams.set('resources[limit]','10');u.searchParams.set('resources[limit_scope]','each');u.searchParams.set('section_id','tf-search-results');
        const response=await fetch(u,{signal:this.request.signal});if(!response.ok)throw Error('Search unavailable');
        const html=await response.text();if(seq!==this.sequence||this.panel.hidden)return;
        const content=new DOMParser().parseFromString(html,'text/html').querySelector('[data-tf-search-response]');if(!content)throw Error('No response');
        this.results.replaceChildren(...content.childNodes);this.status.textContent='';
      }catch(e){if(e.name==='AbortError'||seq!==this.sequence)return;this.status.textContent='Zoeksuggesties zijn tijdelijk niet beschikbaar. Druk op Enter om te zoeken.';}
    }
    remember() {
      this.handles=[];
      try {
        this.handles=JSON.parse(sessionStorage.getItem('tf_recent_products')||'[]');if(!Array.isArray(this.handles))this.handles=[];
        const current=this.querySelector('.tf-s-current');if(current){const h=JSON.parse(current.textContent);this.handles=[h,...this.handles.filter(x=>x!==h)].slice(0,8);sessionStorage.setItem('tf_recent_products',JSON.stringify(this.handles));}
      }catch(e){this.handles=[];}
      this.handles=this.handles.filter(h=>typeof h==='string'&&/^[a-z0-9-]+$/.test(h)).slice(0,2);
    }
    async recent() {
      const list=this.panel.querySelector('.tf-s-recent-list');
      const products=await Promise.all(this.handles.map(async h=>{try{const r=await fetch(this.base+'products/'+encodeURIComponent(h)+'.js',{signal:this.events.signal});return r.ok?await r.json():null;}catch(e){return null;}}));
      if(!this.isConnected)return;
      const money=v=>new Intl.NumberFormat(this.dataset.locale||'nl',{style:'currency',currency:this.dataset.currency||'EUR',minimumFractionDigits:v%100===0?0:2,maximumFractionDigits:2}).format(v/100).replace(/\u00a0/g,'');
      for(const p of products.filter(Boolean)){
        const priceVariant=(p.variants||[]).reduce((lowest,variant)=>!lowest||variant.price<lowest.price?variant:lowest,null)||{price:p.price};
        const a=document.createElement('a');a.className='tf-s-recent-card';a.href=this.base+'products/'+encodeURIComponent(p.handle);
        if(p.featured_image){const img=document.createElement('img');img.src=p.featured_image;img.alt='';img.loading='lazy';a.append(img);}
        const text=document.createElement('span');const name=document.createElement('span');name.className='tf-s-name';name.textContent=p.title;text.append(name);
        const prices=document.createElement('span');prices.className='tf-s-prices';const price=document.createElement('strong');price.textContent=money(priceVariant.price);prices.append(price);
        if(priceVariant.compare_at_price>priceVariant.price){const old=document.createElement('s');old.textContent=money(priceVariant.compare_at_price);prices.append(old);}text.append(prices);a.append(text);list.append(a);
      }
      this.panel.querySelector('.tf-s-empty').hidden=!!list.children.length;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);this.request?.abort();this.events?.abort();
      if(this.header&&this.savedZ!==undefined)this.header.style.zIndex=this.savedZ;
      this.panel?.remove();this.shade?.remove();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tfb-collection-mobile-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-tfb-filter-close]');
    if (closeButton) {
      event.preventDefault();
      closeButton.closest('dialog').close();
      return;
    }
    if (event.target.matches('dialog.tfb-mobile-filters__panel')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
      return;
    }
    const trigger = event.target.closest('[data-tfb-filter-target]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    const root = trigger.closest('.tfb-mobile-filters');
    const panel = root.querySelector('.tfb-mobile-filters__panel');
    root.querySelectorAll('[data-tfb-filter-target]').forEach(button => button.setAttribute('aria-expanded', String(button === trigger)));
    panel.querySelector('h2').textContent = trigger.querySelector('strong')?.textContent.replace(/:$/, '') || trigger.querySelector('span').textContent;
    panel.querySelectorAll('[data-tfb-inline-group]').forEach(group => {
      group.hidden = group.dataset.tfbInlineGroup !== trigger.dataset.tfbFilterTarget;
      const details = group.querySelector('details');
      if (details) details.open = !group.hidden;
    });
    panel.onclose = () => {
      trigger.setAttribute('aria-expanded', 'false');
      if (trigger.isConnected) trigger.focus();
    };
    panel.showModal();
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tfb-combi-upgrade"] && !Shopify.designMode) return;
  try {
    (() => {
  const storageKey = 'tfb-upgrade-intent';
  const stateKey = 'tfbUpgradeVisit';
  const parameter = 'tfb_upgrade_from';
  const rememberUpgrade = (event) => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target instanceof Element ? event.target.closest('a[data-tfb-upgrade-source][data-tfb-upgrade-deal]') : null;
    if (!link || event.defaultPrevented) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        source: link.dataset.tfbUpgradeSource,
        deal: link.dataset.tfbUpgradeDeal,
        time: Date.now()
      }));
    } catch {}
  };
  if (!customElements.get('tfb-deal-return')) {
    document.addEventListener('click', rememberUpgrade, true);
    document.addEventListener('auxclick', rememberUpgrade, true);
    customElements.define('tfb-deal-return', class extends HTMLElement {
      connectedCallback() {
        const url = new URL(location.href);
        const marker = url.searchParams.get(parameter);
        const source = this.dataset.source;
        const deal = this.dataset.deal;
        const state = history.state && typeof history.state === 'object' ? history.state : {};
        const previousVisit = state[stateKey];
        let allowed = !marker && previousVisit?.source === source && previousVisit?.deal === deal;
        if (marker) {
          let intent;
          try {
            intent = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
            sessionStorage.removeItem(storageKey);
          } catch {}
          const age = intent ? Date.now() - intent.time : -1;
          allowed = marker === source && intent?.source === source && intent?.deal === deal && age >= 0 && age < 120000;
          const nextState = { ...state };
          if (allowed) nextState[stateKey] = { source, deal };
          else delete nextState[stateKey];
          url.searchParams.delete(parameter);
          try { history.replaceState(nextState, '', url.href); } catch {}
        }
        this.hidden = !allowed;
      }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
